module.exports = {
  title: '短信管理',
  route: {
    path: '/admin-system-manage',
    children: {
      path: 'short-message-manage',
    },
  },
};
